import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="border-t border-slate-700 bg-slate-950 text-slate-300">
            <div className="mx-auto grid max-w-7xl gap-10 px-6 py-12 sm:px-10 md:grid-cols-[1.4fr_1fr_1fr] lg:px-12">
                <div>
                    <Link to="/" className="text-xl font-bold text-white no-underline">
                        BhuWaivs
                    </Link>
                    <p className="mt-3 max-w-sm text-sm leading-6 text-slate-400">
                        Intelligent seismic monitoring, built for the places and structures that need it most.
                    </p>
                    <p className="mt-4 text-sm text-slate-400">
                        A shriseismic Technology initiative, incubated at TIDE, IIT Roorkee.
                    </p>
                </div>

                <nav aria-label="Footer navigation">
                    <h2 className="text-sm font-semibold uppercase tracking-wider text-white">Explore</h2>
                    <ul className="mt-4 space-y-3 text-sm">
                        <li><Link className="text-slate-400 no-underline transition-colors hover:text-white" to="/">Home</Link></li>
                        <li><Link className="text-slate-400 no-underline transition-colors hover:text-white" to="/about">About</Link></li>
                        <li><Link className="text-slate-400 no-underline transition-colors hover:text-white" to="/device-map">Sensor map</Link></li>
                    </ul>
                </nav>

                <div>
                    <h2 className="text-sm font-semibold uppercase tracking-wider text-white">Monitoring</h2>
                    <p className="mt-4 text-sm leading-6 text-slate-400">
                        View live sensor data and explore seismic activity from connected devices.
                    </p>
                    <Link
                        to="/live-graph"
                        className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-orange-400 no-underline transition-colors hover:text-orange-300"
                    >
                        Open live dashboard <span aria-hidden="true">→</span>
                    </Link>
                </div>
            </div>

            <div className="border-t border-slate-800">
                <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-5 text-xs text-slate-500 sm:px-10 md:flex-row md:items-center md:justify-between lg:px-12">
                    <span>&copy; {new Date().getFullYear()} BhuWaivs. All rights reserved.</span>
                    <span>Seismic monitoring for a more resilient world.</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
